import { render, staticRenderFns } from "./AiChatDrawer.vue?vue&type=template&id=130cbc02&scoped=true"
import script from "./AiChatDrawer.vue?vue&type=script&lang=js"
export * from "./AiChatDrawer.vue?vue&type=script&lang=js"
import style0 from "./AiChatDrawer.vue?vue&type=style&index=0&id=130cbc02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130cbc02",
  null
  
)

export default component.exports